import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./BlogDetailPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import ReplyForm from "../../Common/BlogReply";
import {blog_detail} from "../../data";

function App() {
  return <X09BlogsDetailsPageDesktop {...x09BlogsDetailsPageDesktopData} />;
}

export default App;

function X09BlogsDetailsPageDesktop(props) {
  const {
    text146,
    group182,
    address,
    text147,
    rectangle97,
    rectangle98,
    followUs,
    f1,
    overlapGroup2,
    vector2,
    line56,
    ellipse105,
    spanText,
    spanText2,
    text149,
    line57,
    leaveAReply,
    //group89Props,
    twitter3Props,
    button11Props,
    textInputsNormal42Props,
    textInputsNormal22Props,
    textInputsNormal222Props,
    textInputsNormal223Props,
    //footer32Props,
    //headerWithBackground22Props,
  } = props;

  return (
    <div className="bdpd-container-center-horizontal">
     
      <div className="bdpd-x09-blogs-details-page-desktop">
        <div className="bdpd-overlap-group">
          <div className="bdpd-frame-1596">
            <div className="bdpd-overlap-group">
              <h1 className="bdpd-text-1 bdpd-valign-text-middle">{text146}</h1>
              {/* <img className="bdpd-group-182" src={group182} /> */}
              <img className="bdpd-group-182" src={blog_detail.BlogDetailHeader} />
              <div className="bdpd-group-196">
                <div className="bdpd-address bdpd-valign-text-middle bdpd-typographybody16-regular">{address}</div>
                <p className="bdpd-text-2">{text147}</p>
              </div>
              {/* <Group89
                line4={group89Props.line4}
                line5={group89Props.line5}
                line6={group89Props.line6}
                line7={group89Props.line7}
                line8={group89Props.line8}
              /> */}
              
              {/* <img className="bdpd-rectangle-97" src={rectangle97} /> */}
              <img className="bdpd-rectangle-97" src={blog_detail.BlogDetailCard1} />

              {/* <img className="bdpd-rectangle-98" src={rectangle98} /> */}
              <img className="bdpd-rectangle-98" src={blog_detail.BlogDetailCard2} />
              <div className="bdpd-group-198">
                <div className="bdpd-follow-us bdpd-valign-text-middle">{followUs}</div>
                <div className="bdpd-frame-1561">
                  <div className="bdpd-facebook-app-symbol">
                    <img className="bdpd-f-1" src={f1} />
                  </div>
                  <div className="bdpd-instagram">
                    <div className="bdpd-overlap-group2" style={{ backgroundImage: `url(${overlapGroup2})` }}>
                      <img
                        className="bdpd-vector"
                        src="/Images/Blogs_detail/instagram2.svg"
                      />
                      <img className="bdpd-vector-1" src={vector2} />
                    </div>
                  </div>
                  <Twitter3 src={twitter3Props.src} />
                </div>
              </div>
              <div className="bdpd-frame-200">
                <img className="bdpd-line-56" src={line56} />
                <div className="bdpd-frame-1646">


                  {/* <img className="bdpd-ellipse-105" src={ellipse105} /> */}
                  <img className="bdpd-ellipse-105" src={blog_detail.BlogDetailWriter} />
                  <div className="bdpd-frame-199">
                    <div className="bdpd-text-3 bdpd-valign-text-middle">
                      <span>
                        <span className="bdpd-span0 ">{spanText}</span>
                        <span className="bdpd-span1 ">{spanText2}</span>
                      </span>
                    </div>
                    <p className="bdpd-text-4 bdpd-typographybodycaption-14-semi-bold">{text149}</p>
                  </div>
                </div>
                <img className="bdpd-line-57" src={line57} />
              </div>
              <Button11>{button11Props.children}</Button11>
              <div className="bdpd-frame-1649">
                <div className="bdpd-leave-a-reply bdpd-valign-text-middle bdpd-typographyheadlineh2-extrabold-40">{leaveAReply}</div>
                {/* <div className="bdpd-frame-1648">
                  <TextInputsNormal42>{textInputsNormal42Props.children}</TextInputsNormal42>
                  <div className="bdpd-frame-1647">
                    <TextInputsNormal22>{textInputsNormal22Props.children}</TextInputsNormal22>
                    <TextInputsNormal22 className={textInputsNormal222Props.className}>
                      {textInputsNormal222Props.children}
                    </TextInputsNormal22>
                    <TextInputsNormal22 className={textInputsNormal223Props.className}>
                      {textInputsNormal223Props.children}
                    </TextInputsNormal22>
                  </div>
                </div> */}
                <ReplyForm />
              </div>
              {/* <Footer32
                group32Props={footer32Props.group32Props}
                frame5Props={footer32Props.frame5Props}
                frame6Props={footer32Props.frame6Props}
                frame7Props={footer32Props.frame7Props}
              /> */}
              <div className="bdpd-footer">
                <Footer />
              </div>
            </div>
          </div>
          {/* <HeaderWithBackground22 {...headerWithBackground22Props} /> */}
          <NavBar />
        </div>
      </div>
      
    </div>
  );
}


function Group89(props) {
  const { line4, line5, line6, line7, line8 } = props;

  return (
    <div className="bdpd-group-89">
      <img className="bdpd-line-4" src={line4} />
      <img className="bdpd-line" src={line5} />
      <img className="bdpd-line" src={line6} />
      <img className="bdpd-line" src={line7} />
      <img className="bdpd-line-8" src={line8} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="bdpd-twitter">
      <img className="bdpd-vector-2" src={src} />
    </div>
  );
}


function Button11(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x26012776TimelineData);
  }, []);

  return (
    <div className="bdpd-x26012776 component component-wrapper not-ready">
      {/* <div className="bdpd-master-button-Bjvkei">
        <div className="bdpd-button-i2601277651-RQP1VA bdpd-valign-text-middle">{children}</div>
      </div> */}
    </div>
  );
}

const x26012776TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".bdpd-x26012776",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {
          "": {
            position: "relative",
          },
        },
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {
          "": {
            position: "relative",
          },
        },
      },
    },
  },
];


function TextInputsNormal42(props) {
  const { children } = props;

  return (
    <div className="bdpd-text-inputs-normal">
      <div className="bdpd-frame-1 bdpd-border-1px-light-grey">
        <div className="bdpd-text-i26012782671 bdpd-inter-normal-sonic-silver-14px">{children}</div>
      </div>
    </div>
  );
}


function TextInputsNormal22(props) {
  const { children, className } = props;

  return (
    <div className={`bdpd-text-inputs-normal-2 ${className || ""}`}>
      <div className="bdpd-frame-1-1 bdpd-border-1px-light-grey">
        <div className="bdpd-text-i26012780671 bdpd-inter-normal-sonic-silver-14px">{children}</div>
      </div>
    </div>
  );
}


// function Footer32(props) {
//   const { group32Props, frame5Props, frame6Props, frame7Props } = props;

//   return (
//     <div className="bdpd-footer">
//       <div className="bdpd-frame-1585">
//         <Frame1578
//           overlapGroup1={group32Props.overlapGroup1}
//           vector2={group32Props.vector2}
//           group86222Props={group32Props.group86222Props}
//           facebookAppSymbol3Props={group32Props.facebookAppSymbol3Props}
//           twitter3Props={group32Props.twitter3Props}
//         />
//         <Frame53 text40={frame5Props.text40} frame4Props={frame5Props.frame4Props} />
//         <Frame6
//           text48={frame6Props.text48}
//           frame42Props={frame6Props.frame42Props}
//           frame422Props={frame6Props.frame422Props}
//         />
//       </div>
//       <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
//     </div>
//   );
// }


function Frame1578(props) {
  const { overlapGroup1, vector2, group86222Props, facebookAppSymbol3Props, twitter3Props } = props;

  return (
    <div className="bdpd-frame-1578">
      <Group86222 group85={group86222Props.group85} whiteProps={group86222Props.whiteProps} />
      <div className="bdpd-frame-1584">
        <Group324 />
        <div className="bdpd-frame-1583">
          <FacebookAppSymbol3 src={facebookAppSymbol3Props.src} />
          <div className="bdpd-instagram-1">
            <div className="bdpd-overlap-group2-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img
                className="bdpd-vector-3"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-95@2x.svg"
              />
              <img className="bdpd-vector-4" src={vector2} />
            </div>
          </div>
          <Twitter3 src={twitter3Props.src} />
        </div>
      </div>
    </div>
  );
}


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="bdpd-group-86">
      <White src={whiteProps.src} />
      <img className="bdpd-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="bdpd-white">
      <img className="bdpd-vector-5" src={src} />
    </div>
  );
}


function Group324() {
  return (
    <div className="bdpd-group-32">
      <div className="bdpd-group-189">
        <div className="bdpd-map-pin-1">
          <div className="bdpd-overlap-group2-2">
            <img
              className="bdpd-vector-6"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-90@2x.svg"
            />
          </div>
        </div>
        <p className="bdpd-text-5 bdpd-typographybody16-regular">
          #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
        </p>
      </div>
      <div className="bdpd-group-18">
        <div className="bdpd-phone">
          <img
            className="bdpd-vector-7"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg"
          />
        </div>
        <div className="bdpd-text bdpd-valign-text-middle bdpd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
      </div>
      <div className="bdpd-group-18">
        <div className="bdpd-mail">
          <div className="bdpd-overlap-group2-3">
            <img
              className="bdpd-vector-8"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-93@2x.svg"
            />
          </div>
        </div>
        <div className="bdpd-text bdpd-valign-text-middle bdpd-typographybody16-regular">contact@webuild.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="bdpd-facebook-app-symbol-1">
      <img className="bdpd-f-1-1" src={src} />
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="bdpd-frame-5">
      <div className="bdpd-text-8 bdpd-valign-text-middle bdpd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47 } = props;

  return (
    <div className="bdpd-frame-4">
      <div className="bdpd-text-6 bdpd-valign-text-middle bdpd-typographybody16-regular">{text41}</div>
      <div className="bdpd-text-7 bdpd-valign-text-middle bdpd-typographybody16-regular">{text42}</div>
      <div className="bdpd-text-7 bdpd-valign-text-middle bdpd-typographybody16-regular">{text43}</div>
      <div className="bdpd-text-7 bdpd-valign-text-middle bdpd-typographybody16-regular">{text44}</div>
      <div className="bdpd-text-7 bdpd-valign-text-middle bdpd-typographybody16-regular">{text45}</div>
      <div className="bdpd-text-7 bdpd-valign-text-middle bdpd-typographybody16-regular">{text46}</div>
      <div className="bdpd-text-7 bdpd-valign-text-middle bdpd-typographybody16-regular">{text47}</div>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="bdpd-frame-6">
      <div className="bdpd-text-16 bdpd-valign-text-middle bdpd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="bdpd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, className } = props;

  return (
    <div className={`bdpd-frame-4-1 ${className || ""}`}>
      <div className="bdpd-text-17 bdpd-valign-text-middle bdpd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="bdpd-frame-1580">
        <div className="bdpd-text-9 bdpd-valign-text-middle bdpd-typographybody16-regular">{text50}</div>
        <div className="bdpd-place bdpd-valign-text-middle bdpd-typographybody16-regular">{place}</div>
        <div className="bdpd-text-19 bdpd-valign-text-middle bdpd-typographybody16-regular">{text51}</div>
        <div className="bdpd-text-20 bdpd-valign-text-middle bdpd-typographybody16-regular">{text52}</div>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="bdpd-frame-7">
      <div className="bdpd-text-24 bdpd-valign-text-middle bdpd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


// function HeaderWithBackground22(props) {
//   const {
//     unselectedI2601273,
//     unselectedI26012732,
//     unselectedI26012733,
//     unselectedI26012734,
//     unselectedI26012735,
//     text127,
//     unselectedI26012736,
//     unselectedI26012737,
//     group86Props,
//     getAQuoteButton22Props,
//   } = props;

//   return (
//     <div className="bdpd-header-with-background">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <div className="bdpd-frame-34">
//         <div className="bdpd-frame-27">
//           <div className="bdpd-unselected-i2601279 bdpd-valign-text-middle bdpd-typography-body-smalltext-14-regular">
//             {unselectedI2601273}
//           </div>
//           <div className="bdpd-unselected-i2601279-1 bdpd-valign-text-middle bdpd-typography-body-smalltext-14-regular">
//             {unselectedI26012732}
//           </div>
//           <div className="bdpd-unselected-i2601279-2 bdpd-valign-text-middle bdpd-typography-body-smalltext-14-regular">
//             {unselectedI26012733}
//           </div>
//           <div className="bdpd-unselected-i2601279-3 bdpd-valign-text-middle bdpd-typography-body-smalltext-14-regular">
//             {unselectedI26012734}
//           </div>
//           <div className="bdpd-unselected-i2601279-4 bdpd-valign-text-middle bdpd-typography-body-smalltext-14-regular">
//             {unselectedI26012735}
//           </div>
//           <div className="bdpd-selected">
//             <div className="bdpd-overlap-group1">
//               <div className="bdpd-rectangle-61"></div>
//               <div className="bdpd-text-32 bdpd-valign-text-middle bdpd-overpass-bold-shark-14px">{text127}</div>
//             </div>
//           </div>
//           <div className="bdpd-unselected-i2601279-5 bdpd-valign-text-middle bdpd-typography-body-smalltext-14-regular">
//             {unselectedI26012736}
//           </div>
//           <div className="bdpd-unselected-i2601279-6 bdpd-valign-text-middle bdpd-typography-body-smalltext-14-regular">
//             {unselectedI26012737}
//           </div>
//         </div>
//         <GetAQuoteButton222>{getAQuoteButton22Props.children}</GetAQuoteButton222>
//       </div>
//     </div>
//   );
// }


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="bdpd-group-86-1">
      <White src={whiteProps.src} />
      <img className="bdpd-group-85-1" src={group85} />
    </div>
  );
}


function GetAQuoteButton222(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i2601279164120TimelineData);
  }, []);

  return (
    <div className="bdpd-i26012791-64120 component component-wrapper not-ready">
      <div className="bdpd-master-button-ZLKxLn">
        <div className="bdpd-button-i2601279164-xmtjRp bdpd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i2601279164120TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".bdpd-i26012791-64120",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];

const group89Data = {
    line4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-6@1x.svg",
    line5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-6@1x.svg",
    line6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-6@1x.svg",
    line7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-6@1x.svg",
    line8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-5@1x.svg",
};

const twitter3Data = {
    src: "/Images/Blogs_detail/twiter.svg",
};

const button11Data = {
    children: "POST COMMENT",
};

const textInputsNormal42Data = {
    children: "Comment",
};

const textInputsNormal22Data = {
    children: "Name",
};

const textInputsNormal222Data = {
    children: "Email",
    className: "bdpd-text-inputs-normal-1-1",
};

const textInputsNormal223Data = {
    children: "Phone Number",
    className: "bdpd-text-inputs-normal-1",
};

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: whiteData,
};

const facebookAppSymbol3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-4@2x.svg",
};

const twitter32Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-97@2x.svg",
};

const frame1578Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-94@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-96@2x.svg",
    group86222Props: group86222Data,
    facebookAppSymbol3Props: facebookAppSymbol3Data,
    twitter3Props: twitter32Data,
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
};

const frame422Data = {
    text49: "bdpd-interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "bdpd-frame-5-1",
};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBEMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};

// const footer32Data = {
//     group32Props: frame1578Data,
//     frame5Props: frame53Data,
//     frame6Props: frame6Data,
//     frame7Props: frame7Data,
// };

const white2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: white2Data,
};

const getAQuoteButton222Data = {
    children: "GET A QUOTE",
};

// const headerWithBackground22Data = {
//     unselectedI2601273: "HOME",
//     unselectedI26012732: "ABOUT US",
//     unselectedI26012733: "PROJECTS",
//     unselectedI26012734: "VIDEOS",
//     unselectedI26012735: "INSIGHTS",
//     text127: "BLOGS",
//     unselectedI26012736: "FAQ’S",
//     unselectedI26012737: "CONTACT US",
//     group86Props: group86Data,
//     getAQuoteButton22Props: getAQuoteButton222Data,
// };

const x09BlogsDetailsPageDesktopData = {
    text146: "Lorem Ipsum passages of Lorem Ipsum available",
    group182: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/group-182-1@2x.jpg",
    address: "5 June 2021",
    text147: <>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo, ac tincidunt sem pharetra nec. Nunc faucibus ipsum vel metus aliquam, bdpd-interdum feugiat massa viverra. Donec velit magna, sodales sed convallis eu, egestas vel nisl. Etiam fermentum felis ac risus scelerisque, ac euismod diam finibus. Suspendisse lacus sem, gravida vestibulum ligula et, pulvinar mattis purus.<br /><br />Etiam fermentum felis ac risus scelerisque, ac euismod diam finibus. Suspendisse lacus sem, gravida vestibulum ligula et, pulvinar mattis purus. Phasellus mollis molestie ante sed rhoncus.<br /><br />Sed eu faucibus libero. Nunc at libero eget massa lobortis consectetur vel eu ligula. Suspendisse est mauris, fermentum id pellentesque ut, pharetra quis risus. Aliquam placerat orci turpis, quis venenatis massa lobortis a. Integer nec magna erat. Nullam vel dui vel purus consequat fermentum. Donec rhoncus convallis erat sit amet vestibulum. Duis lacinia, purus eget fermentum volutpat, justo ipsum mattis risus, a efficitur sapien nisi nec augue.</>,
    rectangle97: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/rectangle-97@2x.jpg",
    rectangle98: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/rectangle-98@2x.jpg",
    followUs: "Share:",
    f1: "/Images/Blogs_detail/facebook.svg",
    overlapGroup2: "/Images/Blogs_detail/instagram1.svg",
    vector2: "/Images/Blogs_detail/instagram3.svg",
    line56: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-56@1x.svg",
    ellipse105: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/ellipse-105@2x.png",
    spanText: "Written by:",
    spanText2: " Darlene Robertson",
    text149: "Donec vitae mi metus. Vestibulum ac aliquam ligula. Sed vestibulum eu mi in finibus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
    line57: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-56@1x.svg",
    leaveAReply: "Leave a reply",
    group89Props: group89Data,
    twitter3Props: twitter3Data,
    button11Props: button11Data,
    textInputsNormal42Props: textInputsNormal42Data,
    textInputsNormal22Props: textInputsNormal22Data,
    textInputsNormal222Props: textInputsNormal222Data,
    textInputsNormal223Props: textInputsNormal223Data,
    //footer32Props: footer32Data,
    //headerWithBackground22Props: headerWithBackground22Data,
};

